import type { RulesColor, RulesPiece } from '@/game/rules';

import { pieceAssetUrl, type PieceTheme } from './capturedMaterial';

const THAI_COLOR: Readonly<Record<RulesColor, string>> = {
  w: 'ขาว',
  b: 'ดำ',
};

const THAI_PIECE: Readonly<Record<RulesPiece, string>> = {
  p: 'เบี้ย',
  n: 'ม้า',
  b: 'บิชอป',
  r: 'เรือ',
  q: 'ควีน',
  k: 'คิง',
};

export function CapturedPieceTray({
  color,
  pieces,
  theme,
}: {
  readonly color: RulesColor;
  readonly pieces: readonly RulesPiece[];
  readonly theme: PieceTheme;
}) {
  const colorLabel = THAI_COLOR[color];
  return (
    <section
      className={`captured-tray is-${color === 'w' ? 'white' : 'black'} is-${theme}`}
      aria-label={`ตัวหมากที่ฝ่าย${colorLabel}เสียไป`}
      data-captured-color={color}
      data-piece-theme={theme}
    >
      <strong>ฝ่าย{colorLabel}เสีย</strong>
      {pieces.length === 0 ? (
        <span className="captured-tray__empty">ยังไม่มี</span>
      ) : (
        <ol className="captured-tray__pieces" aria-label={`${pieces.length} ตัว`}>
          {pieces.map((piece, index) => (
            <li key={`${piece}-${index}`} data-captured-piece={piece}>
              <img src={pieceAssetUrl(theme, color, piece)} alt="" aria-hidden="true" />
              <span className="sr-only">{THAI_PIECE[piece]}สี{colorLabel}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
